import { render, staticRenderFns } from "./HistoricoCodigos.vue?vue&type=template&id=7f87f860"
import script from "./HistoricoCodigos.vue?vue&type=script&lang=js"
export * from "./HistoricoCodigos.vue?vue&type=script&lang=js"
import style0 from "./HistoricoCodigos.vue?vue&type=style&index=0&id=7f87f860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports